import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

// Connects to data-controller="controller"
export default class extends Controller {
  static values = {
    showClearButton: {type: Boolean, default: true },

    options: {
      type: Object,
      default: {}
    }
  }

  connect() {
    console.debug("=> Gym Select");

    this.tom = this.element.tomselect || new TomSelect(this.element, {
      plugins: this.showClearButtonValue ? ['dropdown_input', 'clear_button'] : ['dropdown_input'],
      maxOptions: 300,
      create: false,
      sortField: {
        field: "text",
        direction: "asc"
      },
      render: {
        option: function (data, escape) {
          return `
            <div class="">
              <div class="fw-medium pb-1">
                ${data.text}
              </div>
              <div class="d-flex justify-content-between gap-3">
                <div class="text-secondary">
                  ${data.cityName}
                </div>
                
                <div class="
                  text-uppercase text-nowrap badge rounded-pill 
                  text-${data.color}-emphasis bg-${data.color}-subtle border 
                  border-${data.color}-subtle
                ">
                  ${data.gymType}
                </div>
              </div>
            </div>
          `;
        },
      }
    });
  }

  disconnect() {
    this.tom.destroy();
  }

}
